<template>
    <form-input
        v-model.number="model"
        type="number"
        min="0"
        step="1"
    >
        <template #append>
            <q-badge color="input" text-color="input">
                %
            </q-badge>
        </template>
    </form-input>
</template>

<script setup>
const model = defineModel(Number)
</script>
